<template>
	<el-dialog
		:append-to-body="true"
		:modal-append-to-body="false"
		:visible.sync="payOfflineDialogVisible"
		center
		title="对公转账"
		width="50%">
		<PayResult
			:insure-type="payData.insureType"
			:is-add="payData.isAdd"
			:order-id="payData.currentOderId"
			:pay-source="2"
			:pay-types-data="settingConfig.payTypes"
			:pre-pay-notice-data="settingConfig.prePayNotice"
			:product-id="payData.productId"
			:source-product-id="payData.sourceProductId"
			:span-width="20"
			:temp-order-id="payData.orderId"
			:total-price="payData.totalPrice"
			@onToPolicyDetail="onPaySuccess"></PayResult>
	</el-dialog>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'

import PayResult from '@/views/insuranceCenter/components/payResult.vue'
import {dealClearCode} from 'meibao-insure/src/util/commonUtils'
import store from '@/store'
import {getBaseConfigInfo} from 'meibao-insure/src/api/productCenterNew'

export default {
	name: 'payOffLineDialog',
	mixins: [],
	components: {PayResult},
	data() {
		return {
			payOfflineDialogVisible: false,
			settingConfig: {},
			payData: {},
		}
	},
	watch: {},
	methods: {
		//传递数据，直接调用
		async dealData(payData) {
			this.payData = payData
			let {productId, sourceProductId, insureType, orderId, isAdd} = payData
			let query = {
				pid: sourceProductId,
			}
			if (!this.validatenull(productId)) {
				query.npid = productId
			}
			//清空
			let headers = {}
			if (this.envConfig.isBxXsm()) {
				headers = dealClearCode(insureType, store)
			}
			try {
				let refConfig =
					(await getBaseConfigInfo(isAdd, headers, productId, sourceProductId, orderId, {settingSign: 1})) || {}
				let {setting = {}} = refConfig
				this.settingConfig = setting
				this.payOfflineDialogVisible = true
			} catch (e) {
				this.$message.error(e || '获取支付方式失败')
			} finally {
			}
		},
		//支付成功
		onPaySuccess() {
			this.payOfflineDialogVisible = false
			this.$emit('onPayOffLineSuccess')
		},
	},
	created() {},
	mounted() {},
	activated() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger {
	width: 150px;
	border: transparent;
}
</style>
